// Login Form Types
export const CHG_LOGIN_DATA = 'loginForm/changeLoginData'
export const RESET_FORM_DATA = 'loginForm/resetFormData'
export const UPD_ALERT = 'loginForm/updateAlertData'
export const HIDE_ALERT = 'loginForm/hideAlertData'

// Login Form Types
export const CHG_STATUS_DATA = 'statusForm/changeStatusData'
export const SET_APPLICANT_STATUS_DATA = 'statusForm/setStatusData'

// Common Form Types
export const CHG_COMP_ID = 'commonForm/setCompanyData'
export const IS_LOADING = 'commonForm/isLoading'
export const ERR_404 = 'commonForm/isError404'
